import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import campaignsMessages from './sidebarItems/campaignsMessages';
import schedules from './sidebarItems/schedules';
import histories from './sidebarItems/histories';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';

export const getSidebarItems = accountId => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    campaigns(accountId),
    campaignsMessages(accountId),
    histories(accountId),
    schedules(accountId),
    settings(accountId),
    notifications(accountId),
  ],
});
